import { contain } from 'react-container-helper';
import { connect } from 'react-redux';

import { normalizePathname } from 'util/path';

import HeaderHome from './component';

const initState = () => ({
	isSideNaviOpened: false,
});

const mapSetStateToProps = ({ isSideNaviOpened }, { page }, setState) => ({
	isSideNaviOpened,
	page,
	toggleNavi() {
		setState({ isSideNaviOpened: !isSideNaviOpened });
	},
	closeNavi() {
		setState({ isSideNaviOpened: false });
	},
	onClickOutside(e) {
		// prevent close navi when clicking hambuger
		if (e.clientY > 60) {
			setState({ isSideNaviOpened: false });
		}
	},
});

const componentContainer = contain(initState, mapSetStateToProps)(HeaderHome);

const getPage = pathname => {
	const pathnames = normalizePathname(pathname);

	return pathnames[1] === '' ? 'main' : pathnames[1];
};

const mapStateToProps = ({ routing: { locationBeforeTransitions: { pathname } } }) => ({
	page: getPage(pathname),
});

export default connect(mapStateToProps)(componentContainer);



// WEBPACK FOOTER //
// ./src/components/organisms/HeaderHome/index.js